import React, { useMemo } from 'react';
import { getFieldZone } from '../../../constants/rugbyConstants';
import { getAllUniqueTags, getTagsForEventType } from '../../../utils/tagFilterUtils';
import Select from 'react-select';
import './EventsView.css';

const EventsView = ({
    events,
    filteredEvents,
    homeTeamName,
    awayTeamName,
    EVENT_TYPES,
    filters,
    setFilters,
    periods,
    resetFilters
}) => {
    // Get available tags based on events and selected event type
    const availableTags = useMemo(() => {
        // If an event type is selected, only show tags for that event type
        // Otherwise, show all unique tags across all events
        const tagsList = filters.eventType
            ? getTagsForEventType(events, filters.eventType)
            : getAllUniqueTags(events);
            
        // Format tags for react-select
        return tagsList.map(tag => ({
            value: tag,
            label: tag
        }));
    }, [events, filters.eventType]);
    
    // Handle tag selection change
    const handleTagChange = (selectedOptions) => {
        const selectedTags = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setFilters({...filters, tags: selectedTags});
    };
    
    
    return (
        <div className="stats-section">
            <h3 className="stats-section-title">Event Browser</h3>
            
            <div className="events-filter">
                <div className="filter-row">
                    <div className="filter-group">
                        <label className="filter-label">Event Type</label>
                        <select 
                            className="filter-select"
                            value={filters.eventType}
                            onChange={(e) => setFilters({...filters, eventType: e.target.value})}
                        >
                            <option value="">All Event Types</option>
                            {EVENT_TYPES.map(type => (
                                <option key={type} value={type}>{type}</option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="filter-group">
                        <label className="filter-label">Team</label>
                        <select 
                            className="filter-select"
                            value={filters.team}
                            onChange={(e) => setFilters({...filters, team: e.target.value})}
                        >
                            <option value="">Both Teams</option>
                            <option value="Home">{homeTeamName}</option>
                            <option value="Away">{awayTeamName}</option>
                        </select>
                    </div>
                    
                    <div className="filter-group">
                        <label className="filter-label">Period</label>
                        <select 
                            className="filter-select"
                            value={filters.period}
                            onChange={(e) => setFilters({...filters, period: e.target.value})}
                        >
                            <option value="">All Periods</option>
                            {periods.map(period => (
                                <option key={period} value={period}>{period}</option>
                            ))}
                        </select>
                    </div>
                    
                    <div className="filter-group">
                        <label className="filter-label">Zone</label>
                        <select 
                            className="filter-select"
                            value={filters.zone}
                            onChange={(e) => setFilters({...filters, zone: e.target.value})}
                        >
                            <option value="">All Zones</option>
                            <option value="Red Zone">Red Zone</option>
                            <option value="Yellow Zone">Yellow Zone</option>
                            <option value="Green Zone">Green Zone</option>
                        </select>
                    </div>
                    
                    <div className="filter-group tag-filter-group">
                        <label className="filter-label">Tags</label>
                        <Select
                            isMulti
                            name="tags"
                            options={availableTags}
                            className="tag-select-container"
                            classNamePrefix="tag-select"
                            value={filters.tags.map(tag => ({ value: tag, label: tag }))}
                            onChange={handleTagChange}
                            placeholder="Select tags..."
                            noOptionsMessage={() =>
                                filters.eventType
                                    ? "No tags available for this event type"
                                    : "No tags available"
                            }
                            isDisabled={availableTags.length === 0}
                        />
                    </div>
                    
                    <button 
                        className="filter-reset-btn"
                        onClick={resetFilters}
                    >
                        Reset Filters
                    </button>
                </div>
            </div>
            
            <div className="filtered-events-summary">
                Showing {filteredEvents.length} of {events.length} events
            </div>
            
            <div className="events-table-container">
                <table className="events-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Time</th>
                            <th>Period</th>
                            <th>Event</th>
                            <th>Team</th>
                            <th>Zone</th>
                            <th>Comment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredEvents.map((event, index) => (
                            <tr key={event.id}>
                                <td>{index + 1}</td>
                                <td>{event.timestamp}</td>
                                <td>{event.period}</td>
                                <td>{event.eventType}</td>
                                <td className={event.team === 'Home' ? 'home-team' : 'away-team'}>
                                    {event.team === 'Home' ? homeTeamName : awayTeamName}
                                </td>
                                <td className={`zone-cell ${(event.zone || getFieldZone(event.position.x, event.period)).toLowerCase().replace(' ', '-')}`}>
                                    {event.zone || getFieldZone(event.position.x, event.period)}
                                </td>
                                <td className="comment-cell">{event.comment || ''}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EventsView;